/**
 * Create User Interfaces
 * Framework-agnostic type definitions for user creation/import
 */

/**
 * Upload Users Request (FormData)
 */
export interface UploadUsersRequest {
  excel_data: File;
  zip_file?: File;
  role_id: string | number;
  program_id: number;
}

/**
 * Upload Users Response
 */
export interface UploadUsersResponse {
  status: number;
  data: {
    total_count: number;
    success_count: number;
    rejected_count: number;
    rejected_array?: RejectedUser[];
    message: string;
  };
}

/**
 * Rejected User Record
 */
export interface RejectedUser {
  [key: string]: any; // Dynamic fields based on role
}

/**
 * File Names State
 */
export interface FileNamesState {
  csv_file_name: string;
  zip_file_name: string;
  csv_file: File | null;
  zip_file: File | null;
}

/**
 * Download Template Response
 */
export interface DownloadTemplateResponse {
  status: number;
  data: {
    headers: string[];
    message: string;
  };
}

/**
 * Upload Job Result Data
 */
export interface JobResultData {
  status: string;
  stage?: string;
  validation_errors?: string[];
  total_records?: number;
  processed_records?: number;
  passed_records?: number;
  failed_records?: number;
  progress_percentage?: number;
  success_rate?: number;
  message?: string;
  error_csv_path?: string;
  rejection_file?: string;
}

/**
 * Upload Job Record
 */
export interface UploadJob {
  id: number;
  file_name: string;
  file_path: string;
  module_type: string;
  module_label: string | null;
  reference_id: number;
  reference_type: string;
  file_size: number;
  status: string;
  status_label: string;
  total_records: number | null;
  success_records: number | null;
  failed_records: number | null;
  rejected_excel_path: string | null;
  job_id: string | null;
  job_type: string | null;
  job_priority: string | null;
  retry_count: number | null;
  error_message: string | null;
  result_data: JobResultData | null;
  created_date: string;
  updated_date: string;
  completed_at: string | null;
  failed_at: string | null;
}

/**
 * Upload History Response
 */
export interface UploadHistoryResponse {
  success: boolean;
  status: number;
  data: {
    total: number;
    jobs: UploadJob[];
  };
}
